<template>
  <div>
    <!--历史遗留，监控场次页和监控主播页通过 query 判断。。-->
    <!--监控的所有主播-->
    <MonitorAnchorList
      v-if="$route.query.anchor"
      class="monitor-anchor-list"
      :info="monitorAnchorListData"
    />
    <!--当日开播的主播-->
    <template v-else>
      <div class="monitor-live-list">
        <div class="date-monitor-anchor-list align between">
          <div class="date-picker" @click="showDate = !showDate">
            <span class="van-dropdown-menu__title">{{ $formatTime(currentDate, 'MM月DD日') }}</span>
          </div>
          <router-link to="/monitorList?anchor=1" class="to-monitor-list">
            已监控达人
            <icon type="icon" />
          </router-link>
        </div>
        <van-popup v-model="showDate" position="bottom" style="height:5.2rem">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="datePickerConfirm(true)"
            @cancel="datePickerConfirm"
          />
        </van-popup>
      </div>
      <MonitorLiveList :info="monitorLiveListData" />
    </template>
  </div>
</template>

<script>
import MonitorLiveList from '@/modules/monitorList/MonitorLiveList.vue';
import MonitorAnchorList from '@/modules/monitorList/MonitorAnchorList.vue';

export default {
  components: { MonitorLiveList, MonitorAnchorList },
  data() {
    return {
      showDate: false,
      currentDate: new Date(moment().subtract(1, 'days')),
      minDate: new Date(2020, 6, 1),
      maxDate: new Date(),
      monitorLiveListData: [],
      monitorAnchorListData: {}
    };
  },
  mounted() {
    this.query().then(res => {
      this.monitorLiveListData = res[0];
      this.monitorAnchorListData = res[1];
      this.$toast.clear();
    });
  },
  methods: {
    async query() {
      this.$showLoading();
      return await Promise.all([
        this.$get({
          road: 'subscriptionList',
          params: { time: moment(this.currentDate).format('YYYYMMDD') },
          version: 'v2'
        }).catch(err => {
          return [];
        }),
        this.$get({
          road: 'liveStream',
          params: {
            type: 'barrage',
            page: 100,
            index: 1,
            sort: 'startAt',
            order: 'desc'
          },
          version: 'v2'
        }).catch(err => {
          return {};
        })
      ]);
    },
    datePickerConfirm(load) {
      this.showDate = false;
      if (load) {
        this.$showLoading();
        this.$get({
          road: 'subscriptionList',
          params: { time: moment(this.currentDate).format('YYYYMMDD') },
          version: 'v2'
        }).then(res => {
          this.monitorLiveListData = res;
          this.$toast.clear();
        }).catch(err => {
          this.$toast('获取数据失败');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.monitor-live-list {
  width: 100%;
  height: 1rem;
  padding: 0 0.3rem;
  border-bottom: 0.02rem solid #2a89f4;

  .date-monitor-anchor-list {
    height: 1rem;
  }

  .date-picker,
  .to-monitor-list {
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
  }

  .date-picker {
    color: #4a4a4a;
  }

  .to-monitor-list {
    text-align: right;
    color: #2a89f4;
    font-size: 0.28rem;
  }
}
</style>
